import {restorePhotoSession} from './collectionSession';
import type {PhotoCollectionSession} from './contracts';
const prefix='sonata-photo-collection:',memory=new Map<string,PhotoCollectionSession>();
export function photoAccessScope(user:{email?:string;status?:string;roles?:string[];farm_ids?:string[]}|null|undefined,privileges:unknown){
 return JSON.stringify([user?.email,user?.status,[...(user?.roles||[])].sort(),[...(user?.farm_ids||[])].sort(),privileges]);
}
export function readPhotoSession(id:string|null|undefined,scope:string){
 if(!id)return null;let value:unknown=memory.get(id);
 try{const raw=sessionStorage.getItem(prefix+id);if(raw)value=JSON.parse(raw);}catch{/* In-memory navigation remains available when browser storage is full. */}
 return restorePhotoSession(value,scope);
}
export function savePhotoSession(session:PhotoCollectionSession){
 const safe=restorePhotoSession({...session,updatedAt:Date.now()},session.accessScope);if(!safe)throw new Error('This photo collection cannot be restored.');
 memory.set(safe.id,safe);try{sessionStorage.setItem(prefix+safe.id,JSON.stringify(safe));}catch{/* Never claim persistence if storage rejects it; same-tab memory still works. */}
 prunePhotoSessions(safe.accessScope);return safe;
}
export function prunePhotoSessions(scope:string){
 try{for(let i=sessionStorage.length-1;i>=0;i--){const key=sessionStorage.key(i);if(!key?.startsWith(prefix))continue;
  let safe:PhotoCollectionSession|null=null;try{safe=restorePhotoSession(JSON.parse(sessionStorage.getItem(key)||'null'),scope);}catch{/* Invalid navigation data. */}
  if(!safe)sessionStorage.removeItem(key);else memory.set(safe.id,safe);
 }}catch{/* Storage may be denied. */}
 for(const [id,session]of memory)if(!restorePhotoSession(session,scope)){memory.delete(id);try{sessionStorage.removeItem(prefix+id);}catch{}}
 const oldest=[...memory.values()].sort((a,b)=>b.updatedAt-a.updatedAt).slice(12);
 for(const s of oldest){memory.delete(s.id);try{sessionStorage.removeItem(prefix+s.id);}catch{}}
}
